import React from "react";
import styles from "./jsaPermitInfoComponents.module.css";

// Helper function to get field error for Permit Info fields
const getPermitFieldError = (autosaveErrors, fieldName) => {
  const key = `jsa_permit_info.${fieldName}`;
  return autosaveErrors?.fieldErrors?.[key] || null;
};

// JSA V1 Permit Info Components

// Permit Row, consists of the type of permit and a checkbox on whether is needed or not.
export const PermitRow = ({
  permitTypeName,
  permitType,
  value,
  callbacks,
  isOther = false,
  otherValue = null,
}) => {
  // Handling the update functions
  const handlePermitChange = (e) => {
    callbacks.v1Actions.updateJsaPermit(
      callbacks.jsaData,
      permitType,
      e.target.checked,
      callbacks.emitPatch
    );
  };

  // Handling the other permit change (local state only on onChange)
  const handleOtherPermitChange = (e) => {
    callbacks.v1Actions.updateJsaOtherPermitInfo(
      callbacks.jsaData,
      e.target.value,
      null // Don't emit on every keystroke
    );
  };

  // Handle blur - send patch to server
  const handleOtherPermitBlur = (e) => {
    callbacks.v1Actions.updateJsaOtherPermitInfo(
      callbacks.jsaData,
      e.target.value,
      callbacks.emitPatch // Emit on blur
    );
  };

  return (
    <div
      className={`${styles.permitRow} ${
        isOther && value ? styles.permitRowWithInput : ""
      }`}
    >
      <div className={styles.permitRowContent}>
        <label>{permitTypeName}</label>
        <input
          type="checkbox"
          checked={value}
          onChange={handlePermitChange}
          disabled={callbacks.jsaMode === "view"}
        />
      </div>

      {isOther && value && (
        <div className={styles.permitOtherInputContainer}>
          {(() => {
            const otherPermitError = getPermitFieldError(callbacks.autosaveErrors, "other_permit_info");
            return (
              <>
                <input
                  type="text"
                  className={`${styles.permitOtherInput} ${otherPermitError ? styles.inputError : ""}`}
                  value={otherValue || ""}
                  onChange={handleOtherPermitChange}
                  onBlur={handleOtherPermitBlur}
                  disabled={callbacks.jsaMode === "view"}
                  placeholder="Please specify other permit type"
                />
                {otherPermitError && <span className={styles.errorText}>{otherPermitError}</span>}
              </>
            );
          })()}
        </div>
      )}
    </div>
  );
};

// Permit Table, consists of the Permit Row component.
export const PermitTable = ({ callbacks }) => {
  return (
    <div className={styles.jsaPermitCheckboxSection}>
      <PermitRow
        permitTypeName="Safe Work"
        permitType="safeWorkPermit"
        value={callbacks.jsaData.jsaPermitInfo.safeWorkPermit}
        callbacks={callbacks}
      />
      <PermitRow
        permitTypeName="Hot Work"
        permitType="hotWorkPermit"
        value={callbacks.jsaData.jsaPermitInfo.hotWorkPermit}
        callbacks={callbacks}
      />
      <PermitRow
        permitTypeName="Confined Space"
        permitType="confinedSpacePermit"
        value={callbacks.jsaData.jsaPermitInfo.confinedSpacePermit}
        callbacks={callbacks}
      />
      <PermitRow
        permitTypeName="Excavation"
        permitType="excavationPermit"
        value={callbacks.jsaData.jsaPermitInfo.excavationPermit}
        callbacks={callbacks}
      />
      <PermitRow
        permitTypeName="Lockout/Tagout"
        permitType="lockoutTagoutPermit"
        value={callbacks.jsaData.jsaPermitInfo.lockoutTagoutPermit}
        callbacks={callbacks}
      />
      <PermitRow
        permitTypeName="Other"
        permitType="otherPermit"
        value={callbacks.jsaData.jsaPermitInfo.otherPermit}
        callbacks={callbacks}
        isOther={true}
        otherValue={callbacks.jsaData.jsaPermitInfo.otherPermitInfo}
      />
    </div>
  );
};

// JSA V1 Permit Tab
export const JsaPermitInfoTab = ({ callbacks }) => {
  return (
    <div className={styles.jsaPermitInfoContainer}>
      <div className={styles.jsaPermitInfoHeader}>
        <div className={styles.jsaPermitInfoHeaderText}>
          <p>
            Please indicate if the following permits are required for the work
            being performed.
          </p>
          <p>
            Take note that if a permit is required, it must be completed before
            the work can begin, and have a paper copy of the permit on site.
          </p>
        </div>
      </div>
      <PermitTable callbacks={callbacks} />
    </div>
  );
};
